import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { showAlert } from "store/reducers/alertReducer";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { inviteOrgnisationValues } from "components/constants/InitialFormValues";
import Spinners from "components/common/Spinners";
import { inviteOrganitation } from "store/actions/organizationSlice";
import { inviteOrgnisationSchema } from "components/common/Validation";
import FormButtons from "components/common/FormButtons";
import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import CustomPhoneInput from "components/common/CustomPhoneInput";
import CustomError from "components/common/CustomError";

function InviteOrganisation() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(inviteOrgnisationValues);

  const { isLoading, loading } = useSelector((state) => state.Organizations);
  document.title = t("Invite Organisation | Work space");

  const handleOnSubmit = (values) => {
    dispatch(inviteOrganitation(values))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          navigate(-1);
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content common_page invite_organisation">
        <Container fluid>
          <Row>
            <DetailsPageTitle title={t("Invite Organisation")} />
          </Row>
          <Formik
            initialValues={formValues}
            validationSchema={inviteOrgnisationSchema}
            enableReinitialize={true}
            onSubmit={handleOnSubmit}
          >
            {({ values, setFieldValue, errors, touched }) => (
              <Form>
                <Row className="common_wrapper">
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel htmlFor="name" label={t("Name")} />
                      <CustomField
                        name="name"
                        type="text"
                        placeholder={t("Enter Organisation Name")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel htmlFor="nameAr" label={t("Email")} />
                      <CustomField
                        name="email"
                        type="text"
                        placeholder={t("Enter Organisation Email")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="phoneNumber"
                        label={t("Phone Number")}
                      />

                      <CustomPhoneInput
                        initialPhoneCode={values.phoneCode}
                        initialPhoneNumber={values.phoneNumber}
                        onChange={({ phoneNumber, countryCode }) => {
                          setFieldValue("phoneNumber", phoneNumber);
                          setFieldValue("phoneCode", countryCode);
                        }}
                      />
                      <CustomError name={`phoneNumber`} />
                    </div>
                  </Col>
                  {/* <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel htmlFor="name" label={t("Subdomain")} />
                      <CustomField
                        name="subdomain"
                        type="text"
                        placeholder={t("Enter Subdomain")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  </Col> */}
                </Row>
                <Row className="px-0 my-4">
                  <FormButtons
                    isDraftBtn={false}
                    isLoading={isLoading}
                    addBtnText={t("Invite")}
                  />
                </Row>
              </Form>
            )}
          </Formik>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default InviteOrganisation;
